import { initAccordions } from 'components/accordions'

const $bankButtonList = document.querySelectorAll<HTMLButtonElement>('[data-bank-list-button]')

init()

function expandBankContent(event: Event): void {
  const $element = event.currentTarget as HTMLButtonElement
  const expanded = $element.getAttribute('aria-expanded') !== 'false'
  $element.setAttribute('aria-expanded', String(!expanded))

  const $expandableElement = $element.parentNode.querySelector<HTMLDivElement>('[data-bank-list-expandable]')
  $expandableElement.hidden = !$expandableElement.hidden
}

function init(): void {
  initAccordions({ isClosingOthers: true })

  $bankButtonList.forEach(($singleBankButton) => {
    $singleBankButton.addEventListener('click', expandBankContent)
  })
}
